<template>
    <div class="dashboard weflix-admin-dashboard">
        <Sidebar />
        <div class="page">
            <Toolbar />
            <div class="content dashboard">
                <RouterView></RouterView>
            </div>
        </div>
    </div>
</template>

<script>
    import Sidebar from '@/components/Weflix/Sidebar.vue';
    import Footer from '@/components/Admin/Footer/footer.vue';
    import Toolbar from '@/components/Weflix//Tolbar.vue';

    export default {
        data() {
            return {};
        },
        components: {
            Sidebar,
            Footer,
            Toolbar,
        },
        computed: {},
    };
</script>

<style>
    @import url(./global.css);

    body.weflix input.form-control::placeholder,
    body.weflix textarea::placeholder {
        color: #777777 !important;
    }
    .weflix-admin-dashboard .page {
        width: calc(100% - 210px);
        margin-left: 210px;
        height: 100%;
        min-height: 100%;
    }
    .weflix-admin-dashboard .content.dashboard {
        background-color: transparent;
        margin: 0;
        width: 100%;
        padding: 10px 10px;
        height: calc(100% - 80px);
        min-height: calc(100% - 80px);
    }
    @media (max-width: 768px) {
        .weflix-admin-dashboard .page {
            width: calc(100% - 76px);
            margin-left: 76px;
            flex: 1;
        }
    }
</style>
